import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ColumnListComponent } from './components/column-list/column-list.component';
import { ListItemComponent } from './components/list-item/list-item.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutofocusDirective } from './components/autofocus/autofocus.directive';
import { environment } from 'src/environments/environment';
import { AssurcardAngularLibraryModule } from 'assurcard-angular-library';

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule,
        ReactiveFormsModule,
        FormsModule,
        AssurcardAngularLibraryModule.forRoot(environment),
    ],
    exports: [
        AutofocusDirective,
        ColumnListComponent,
        ListItemComponent,
        ReactiveFormsModule,
        FormsModule,
        AssurcardAngularLibraryModule,
        NgxPermissionsModule
    ],
    declarations: [
        AutofocusDirective,
        ColumnListComponent,
        ListItemComponent
    ],
})
export class SharedModule { }
